import { Layout, Typography } from "antd";
import styled from "styled-components";

export const Container = styled(Layout.Header)`
  display: flex;
  align-items: center;
`;

export const ContainerIcon = styled.span`
  margin: 0 !important;
  padding: 0 !important;
  /* color: "#fffff" !important; */
`;

export const Text = styled(Typography.Text)`
  margin: 0 auto !important;
  font-size: 24px !important;
  /* color: var(--codar-font-color-light) !important; */
`;

export const Logo = styled.div`
  height: 32px;
  margin: 0 0 0 0;
  padding: 32px;
  display: flex;
  align-items: center;
  background-color: rgba(230, 230, 230, 0.863);

`;

export const MenuToggle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-right: 8px;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.16);
  }
`;
